import React from 'react';
import { Button, Tooltip } from '@mui/material';

const CustomIconButton = ({
  actionOnClick,
  Icon,
  title,
  backgroundColor,
  iconColor,
  hoverBackgroundColor,
  hoverIconColor,
}: {
  actionOnClick: () => void;
  Icon: any;
  title: string;
  backgroundColor: string;
  iconColor: string;
  hoverBackgroundColor?: string;
  hoverIconColor?: string;
}) => {
  return (
    <Button
      onClick={actionOnClick}
      sx={{
        background: backgroundColor,
        minWidth: '35px',
        width: '35px',
        overflow: 'hidden',
        color: iconColor,
        '&:hover': {
          background: hoverBackgroundColor ? hoverBackgroundColor : backgroundColor,
          color: hoverIconColor ? hoverIconColor : iconColor,
        },
      }}
    >
      <Tooltip title={title} placement="top">
        {Icon}
      </Tooltip>
    </Button>
  );
};

export default CustomIconButton;
